import styled from 'styled-components'
import { colors, sizes } from 'config/ui'
export const Icon = styled.span`
  font-size: ${props => props.size || 20}px;
  color: ${props => props.color || colors.white};

  @media (min-width: ${sizes.sScreen}px) {
    ${props => (props.colorDesktop ? `color: ${props.colorDesktop};` : '')};
  }
`
